import { render } from "./AdminChatReports.vue?vue&type=template&id=b05e8f6a&scoped=true"
import script from "./AdminChatReports.vue?vue&type=script&lang=js"
export * from "./AdminChatReports.vue?vue&type=script&lang=js"

import "./AdminChatReports.vue?vue&type=style&index=0&id=b05e8f6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b05e8f6a"]])

export default __exports__